import i18n from '@i18next/i18n';
import ImageDetector from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-detector';

export const ImageEditErrors = {
    tooLarge: i18n.t('请选择20M以内的图片插入'),
    commonError: i18n.t('未能成功插入图片，请稍后再试。'),
    networkOffline: i18n.t('网络异常，不支持插入图片，请在网络正常后再试。'),
    broken: i18n.t('部分图片未能成功插入，图片损坏或不支持该格式。'),
} as const;

const MB = 1024 ** 2;
const MAX_IMAGE_SIZE_IN_BYTES = 20 * MB;

export class ImageValidator {
    /**
     * 检查文件是否为合法图片
     * @param blob 文件对象
     *
     * @example
     * ```ts
     * const { NO_BLOB } = ImageValidator.Reason
     * const [isValid, reason] = ImageValidator.checkImageBlob(blob)
     * if (!isValid) {
     *    if (reason === NO_BLOB) {
     *        toast.error('not a valid blob')
     *    }
     * }
     * ```
     */
    public static checkImageBlob = (blob: Blob): [true] | [false, string] => {
        if (!blob || !ImageDetector.isImage(blob) || ImageDetector.isTIFF(blob)) {
            return [false, ImageEditErrors.broken];
        }

        if (blob.size > MAX_IMAGE_SIZE_IN_BYTES) {
            return [false, ImageEditErrors.tooLarge];
        }

        return [true];
    };
}
